export enum MessageType {
    NORMAL = 0,
    WARN = 1,
    ALERT = 2,
}
